export enum Paths {
   LOGIN = "/",
   REQUEST_CHANGE_PASSWORD = "request-change-password",
   CHANGE_PASSWORD_EXTERNAL = "reset-password",
   CHANGE_PASSWORD = "change-password",
   HOME = "home",
   ENGAGEMENT = "engagements",
   CONFIG = "configs",
   JOBS = "jobs",
   CREATE = "create",
   CREATE_V2 = "createV2",
   CONTENT_CATALOG = "contentCatalog",
   CREATE_V3 = "createV3",
   MY_TODOS = "my-todos",
   MY_TODOS_REVIEW = "my-todos/review",
   /** One playbook, reviewed by the client before any of it sends (MPN-2207). */
   SEQUENCE_REVIEW = "my-todos/sequence-review",
   ORGANIZATIONS = "organizations",
   ORGANIZATION_DETAIL = "organization",
   FONT_UPLOADER = "font-uploader",
   MOTI_STORE = "moti-store",
   CLIENT_DASHBOARD_LEGACY = "dashboards/client/legacy",
   OP_LAUNCHES = "dashboards/op-launches",
   OP_LAUNCH_DETAIL = "dashboards/op-launches/:launchId",
   OP_LAUNCH_DASHBOARD = "dashboards/op-launch-dashboard",
   BANNERS = "banners",
   BANNER_NEW = "banners/new",
   BANNER_EDIT = "banners/:bannerId/edit",
   OP_REPORTS = "dashboards/op-reports",
   OP_REPORT = "dashboards/op-reports/:key",
   CONTENT_CATALOG_FILTERED = "#contentCatalogFiltered",
   NETWORK_TEMPLATES = "network_templates",
   TRACER = "tracer",
   OPS_DASHBOARD = "ops-dashboard",
   PERMISSIONS = "permissions",
   HOLDOUT_REPORT = "holdout-test-results",
   JOURNEY_STEPS = "journey-steps",
   CATALOG = "catalog",
   EMAIL_SMS_CATALOG = "email-sms-catalog",
   INGEST_FILES = "configs/:configId/files",
   QUARANTINE = "quarantine",
   DATA_ISSUES = "data-issues",
  FIELD_MAP = "configs/:configId/field-map",
  INSTRUCTIONS = "configs/:configId/instructions",
   UPLOADS = "uploads",
   UPLOAD = "uploads/:configId",
   ACCOUNT_SETUP = "account-setup",
   NOTEBOOK_POPOUT = "notebook",
   NO_ACCESS = "no-access",
   CONTRACT_DETAIL = "contracts",
   CONTRACT_PRICESHEET = "contracts/:contractId/pricesheets/:pricesheetId",
}
